export function validateBessForm(values) {
  const errors = {};

  if (!values.name || !values.name.trim()) {
    errors.name = "Project Name is required";
  }

  // Project configuration
  if (!values.start_year) {
    errors.start_year = "Start Year is required";
  } else if (values.start_year < 2000 || values.start_year > 2100) {
    errors.start_year = "Start Year must be between 2000 and 2100";
  }

  if (!values.simulation_tenure) {
    errors.simulation_tenure = "Simulation Tenure is required";
  } else if (values.simulation_tenure < 1 || values.simulation_tenure > 50) {
    errors.simulation_tenure = "Tenure must be between 1 and 50 years";
  }

  if (!values.operation_hour) {
    errors.operation_hour = "Operation Hour is required";
  } else if (values.operation_hour < 1 || values.operation_hour > 24) {
    errors.operation_hour = "Operation Hour must be between 1 and 24 hours";
  }

  if (!values.simulation_type) {
    errors.simulation_type = "Simulation Type is required";
  }

  // Equipment configuration
  if (!values.container_batch) {
    errors.container_batch = "Battery Container is required";
  }

  if (!values.pcs) {
    errors.pcs = "PCS System is required";
  }

  if (values.simulation_type !== "auto_closed_loop") {
    if (!values.container_nos) {
      errors.container_nos = "Container Qty is required";
    } else if (values.container_nos < 1) {
      errors.container_nos = "Quantity must be at least 1";
    }

    if (!values.pcs_nos) {
      errors.pcs_nos = "PCS Qty is required";
    } else if (values.pcs_nos < 1) {
      errors.pcs_nos = "Quantity must be at least 1";
    }
  }

  if (values.simulation_type === "auto_closed_loop") {
    if (!values.min_aug_period) {
      errors.min_aug_period = "Min Aug Period is required";
    } else if (values.min_aug_period < 1) {
      errors.min_aug_period = "Must be at least 1 year";
    }

    if (!values.min_aug_container) {
      errors.min_aug_container = "Min Aug Container is required";
    } else if (values.min_aug_container < 1) {
      errors.min_aug_container = "Must be at least 1";
    }

    if (!values.max_storage_capacity) {
      errors.max_storage_capacity = "Max Storage Capacity is required";
    } else if (values.max_storage_capacity <= 0) {
      errors.max_storage_capacity = "Must be greater than 0";
    }
  }

  // Plant parameters
  if (!values.energy_poi_mwh) {
    errors.energy_poi_mwh = "Energy @ POI is required";
  } else if (values.energy_poi_mwh <= 0) {
    errors.energy_poi_mwh = "Energy @ POI must be greater than 0";
  }

  // Validate that at least one transmission line loss type is selected
  if (!values.use_220kv_loss && !values.use_400kv_loss) {
    errors.transmission_line_220kv_loss = "At least one transmission line loss type must be selected";
  }

  // System Losses
  const lossFields = [
    ...(values.use_220kv_loss ? ["transmission_line_220kv_loss"] : []),
    ...(values.use_400kv_loss ? ["transmission_line_400kv_loss"] : []),
    ...(Boolean(values.use_transformer_220_loss) ? ["transformer_220kv_loss"] : []),
    ...(Boolean(values.use_transformer_400_loss) ? ["transformer_400kv_loss"] : []),
    "ht_ac_cable_loss",
    "idt_loss",
    "lt_ac_cable_loss",
    "pcs_loss",
    "lt_dc_cable_loss"
  ];
  lossFields.forEach((field) => {
    if (values[field] === undefined || values[field] === null || values[field] === "") {
      errors[field] = "This field is required";
    } else if (values[field] < 0 || values[field] > 100) {
      errors[field] = "Loss must be between 0% and 100%";
    }
  });

  // Solar Aux Power
  if (values.solar_aux_power === undefined || values.solar_aux_power === null || values.solar_aux_power === "") {
    errors.solar_aux_power = "This field is required";
  } else if (values.solar_aux_power < 0) {
    errors.solar_aux_power = "Solar Aux Power must be at least 0 kW";
  }


  // Availability
  if (values.bess_plant_unavailability === undefined || values.bess_plant_unavailability === null || values.bess_plant_unavailability === "") {
    errors.bess_plant_unavailability = "Availability is required";
  } else if (values.bess_plant_unavailability < 0 || values.bess_plant_unavailability > 100) {
    errors.bess_plant_unavailability = "Availability must be between 0% and 100%";
  }

  // Dynamic Closed Loop Validation
  if (values.simulation_type === "closed_loop") {
    if (!values.purchase_years || !Array.isArray(values.purchase_years) || values.purchase_years.length === 0) {
      errors.purchase_years = "At least one purchase year must be added";
    } else {
      // Check each purchase year
      for (const item of values.purchase_years) {
        if (typeof item === "object" && item !== null) {
          const yr = Number(item.year);
          const ctrs = Number(item.containers);
          if (isNaN(yr) || yr < 1 || yr > values.simulation_tenure) {
            errors.purchase_years = `Purchase years must fall within simulation tenure (1 to ${values.simulation_tenure})`;
            break;
          }
          if (isNaN(ctrs) || ctrs < 1) {
            errors.purchase_years = "Container count must be at least 1";
            break;
          }
        } else {
          const yr = Number(item);
          if (isNaN(yr) || yr < 1 || yr > values.simulation_tenure) {
            errors.purchase_years = `Purchase years must fall within simulation tenure (1 to ${values.simulation_tenure})`;
            break;
          }
        }
      }
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}
